<div class="flex w-full overflow-hidden rounded-2xl relative" data-cy="portfolio-card-item">
	<div class="absolute inset-x-0 inset-y-px flex w-full justify-between">
		<!-- Width is pinned to the list's `swipeWidth`, so a full swipe reveals the
			strip exactly. `flex-1` gives the two actions an equal share of what is
			left once the margins and the gap are taken out. -->
		<div class="flex h-full w-39 justify-end gap-1" data-cy="portfolio-card-swipe-right-actions">
			<a
				class="flex flex-1 text-3.25 mr-1 items-center justify-center text-center text-gray-000 gap-0.5 rounded-2xl bg-green-500"
				data-cy="portfolio-card-buy-action"
				[attr.aria-label]="'خرید ' + asset().symbolName"
				[routerLink]="['/order-form', asset().symbolISIN, OrderSide.Buy]">
				خرید
			</a>
			<a
				class="flex flex-1 text-3.25 ml-1 items-center justify-center text-center text-gray-000 gap-0.5 rounded-2xl bg-red-500"
				data-cy="portfolio-card-sell-action"
				[attr.aria-label]="'فروش کل دارایی ' + asset().symbolName"
				[routerLink]="['/order-form', asset().symbolISIN, OrderSide.Sell, asset().quantity]">
				فروش کل دارایی
			</a>
		</div>
	</div>
	<div
		#swipeableCard
		swipeable
		appLongPress
		class="flex w-full flex-col gap-2 p-3 z-1 relative bg-gray-000"
		[id]="asset().contractId">
		<div class="flex w-full items-center justify-between gap-2">
			<!-- The only route to the symbol page. The card body itself is not
				clickable: the three-dot button is the card's other action, and a
				whole-card target would swallow taps meant for it. -->
			<a
				class="flex min-w-0 cursor-pointer items-center gap-1.5"
				data-cy="portfolio-card-symbol"
				[routerLink]="['/symbol-details', asset().symbolISIN]"
				[attr.aria-label]="'نمایش جزئیات نماد ' + asset().symbolName">
				@if (asset().icon; as icon) {
					<ui-icon width="24" height="24" class="shrink-0 text-gray-900" [iconName]="icon" />
				}
				<span class="truncate text-3.25 font-bold text-gray-900">{{ asset().symbolShortName }}</span>
			</a>

			<div class="flex shrink-0 items-center gap-1 font-medium">
				<span class="text-2.75 text-gray-600">تعداد:</span>
				<ui-number
					format="1.0-0"
					class="text-xs tabular-nums text-gray-900"
					data-cy="portfolio-card-quantity"
					[value]="asset().quantity" />
			</div>
		</div>

		<ui-divider tip="050" />

		<div class="flex w-full items-center gap-1">
			<div class="flex shrink-0 flex-col justify-center gap-0.5 text-3.25 font-medium">
				<div class="flex justify-end items-center gap-0.5" dir="ltr">
					<ui-number
						format="1.0-0"
						class="tabular-nums text-gray-900"
						data-cy="portfolio-card-price"
						[value]="asset().price" />
					<span
						data-cy="portfolio-card-price-change-percent"
						[class.text-green-500]="isPriceChangePositive() && !isPriceChangeUnchanged()"
						[class.text-red-500]="!isPriceChangePositive()"
						[class.text-gray-900]="isPriceChangeUnchanged()">
						{{ formattedPriceChangePercent() }}
					</span>
				</div>

				<ui-number
					format="1.0-0"
					class="tabular-nums text-gray-900"
					data-cy="portfolio-card-break-even-price"
					[value]="asset().breakEvenPrice" />
			</div>

			<!-- ارزش فعلی and سود زیان فعلی — the two figures the eye toggle hides. -->
			<div class="flex min-w-0 flex-1 flex-col items-end justify-center gap-0.5 text-3.25 font-medium">
				@if (amountsHidden()) {
					<span class="font-black text-gray-900" data-cy="portfolio-card-net-sale-value">
						{{ maskedValue }}
					</span>

					<span class="font-black text-gray-900" data-cy="portfolio-card-profit-loss">
						{{ maskedValue }}
					</span>
				} @else {
					<ui-number
						format="1.0-0"
						class="tabular-nums text-gray-900"
						data-cy="portfolio-card-net-sale-value"
						[value]="asset().netSaleValue" />

					<div
						dir="ltr"
						class="flex items-center gap-1"
						[class.text-green-500]="isProfit()"
						[class.text-red-500]="!isProfit()">
						<ui-number
							format="1.0-0"
							class="tabular-nums"
							data-cy="portfolio-card-profit-loss"
							[value]="asset().profitLoss" />
						<span data-cy="portfolio-card-profit-loss-percent">{{ formattedProfitLossPercent() }}</span>
					</div>
				}
			</div>

			<!-- `shortClick` rides on `touchend`/`mouseup`, which bubble, so stopping the
				click alone would still let the card's own tap handler run. Stopping
				propagation on those events instead would also keep them from reaching
				`SwipeRightLeftDirective` on the list container, leaving a swiped-open
				row stuck — so the press is flagged here and the resulting navigation is
				suppressed in `onCardClick` instead. -->
			<button
				type="button"
				class="flex size-5 shrink-0 items-center justify-center text-gray-600 cursor-pointer"
				data-cy="portfolio-card-detail-button"
				aria-label="جزئیات پرتفوی"
				(click)="onDetailClick()">
				<ui-icon width="20" height="20" iconName="menu-vertical" />
			</button>
		</div>
	</div>
</div>
